var _rect, _rect2, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoodicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.66675,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#96CEFD"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.66675,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    stroke: "#B5DEFF",
    strokeWidth: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.6667 30C24.6667 30 26.1667 32 28.6667 32C31.1667 32 32.6667 30 32.6667 30M31.6667 25H31.6767M25.6667 25H25.6767M38.6667 28C38.6667 33.5228 34.1896 38 28.6667 38C23.1439 38 18.6667 33.5228 18.6667 28C18.6667 22.4772 23.1439 18 28.6667 18C34.1896 18 38.6667 22.4772 38.6667 28ZM32.1667 25C32.1667 25.2761 31.9429 25.5 31.6667 25.5C31.3906 25.5 31.1667 25.2761 31.1667 25C31.1667 24.7239 31.3906 24.5 31.6667 24.5C31.9429 24.5 32.1667 24.7239 32.1667 25ZM26.1667 25C26.1667 25.2761 25.9429 25.5 25.6667 25.5C25.3906 25.5 25.1667 25.2761 25.1667 25C25.1667 24.7239 25.3906 24.5 25.6667 24.5C25.9429 24.5 26.1667 24.7239 26.1667 25Z",
    stroke: "#0265DC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoodicon);
export default __webpack_public_path__ + "static/media/Moodicon.606320a8855b5d5d2312099bcff8c1be.svg";
export { ForwardRef as ReactComponent };